import React from "react";

const TargetAudience = () => {
  return (
    <section id="targetAudience">
      <div className="mt-5">
        <div className="row">
          <div className="col-lg-12 px-5 text-left text-lg-start wow fadeInUp ">
            <div className="about-section">
              <h2 className="text-8 fw-400 mb-3">
                <span className="fw-700 text-primary border-3 border-primary offset-lg-1">
                  Target Audience
                </span>
              </h2>

              <br></br>
              <br></br>
              <p
                className="text-5 text-justify offset-lg-1"
                style={{
                  fontFamily: "Poppins",
                  fontWeight: "400px",
                }}
              >
                Physicians from three major disciplines which are
                anesthesiology, cardiology and advance cardiac imaging who are
                directly involved in structural heart disease interventions and
                live imaging can rely on this program.
                <br />
                <br />
              </p>
              <ul className="text-5 text-justify offset-lg-1">
                <li>Cardiac Anesthesiology</li>
                <li>Structural Heart and Valve Interventional Cardiology</li>
                <li>Advance Cardiac Imaging</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
